import Sidebar from '../components/Sidebar.jsx';
import PageHeader from '../components/PageHeader.jsx';
import '../styles/pics.css';

const Software = () => {
    let EggAnalyzer = 'https://static.igem.wiki/teams/5066/software/egg-analyzer.png';
    let EggThreshold = 'https://static.igem.wiki/teams/5066/software/egg-threshold.png';
    let EggOverlay = 'https://static.igem.wiki/teams/5066/software/egg-overlay.png';
    let EggDilated = 'https://static.igem.wiki/teams/5066/software/egg-dilated.png';
    let EggGray = 'https://static.igem.wiki/teams/5066/software/egg-gray.png';
    let EggH2 = 'https://static.igem.wiki/teams/5066/software/eggh2.png';
    let EggUI = 'https://static.igem.wiki/teams/5066/software/eggui.png';
    let CoverPic = 'https://static.igem.wiki/teams/5066/global/bgpic.png';
    let OpenCV = 'https://static.igem.wiki/teams/5066/software/opencv.png';
    let Python = 'https://static.igem.wiki/teams/5066/software/python.png';
    let Analyze = 'https://static.igem.wiki/teams/5066/human-practice/accuracyand-error-rate-of-egg-counting-analyzer.png';

    let sections = [
        { id: 's1', name: 'Mosquito Egg Count Analyzer' },
        { id: 's2', name: 'Making Process' },

    ];

   return (
        <div className='bg-[#d9eaf0]'>
            <PageHeader 
            img={CoverPic} 
            title='Mosquito&nbsp;Egg&nbsp;Counter'  
            customPicture={<img src={'https://static.igem.wiki/teams/5066/cover/software.gif'} alt="Custom" className="w-44 h-44" />}
            />

            <div className='flex flex-col md:flex-row bg-gradient-to-b from-[#d9eaf0] via-[#e8f3f7] to-[#feedfb]'>

                <Sidebar sections={sections} />

                {/* Main Content */}
				<div className='w-full md:w-9/10 p-4 md:p-[80px] space-y-8 md:space-y-16 my-[10px] mx-[5px] rounded-2xl bg-[#fffdf2] shadow-[-2px_4px_8px_-2px_rgba(0,0,0,0.4)]'>

                    <div className='pb-12'>
                        <section id='s1'>
                            <h2 className='text-2xl md:text-3xl font-bold text-[#C94C67] leading-relaxed'>
                                Mosquito Eggs Count Analyzer
                            </h2>
                            <p className='pt-4   text-gray-700 leading-relaxed'>
                            Besides working on the Team Wiki development, we also engaged in the development of an egg-counting picture analyzer. We communicated with the Wetlab team and understood that there is a need to manually count the eggs oviposited by the mosquitoes for oviposition assay. We then studied and researched the possibility of exploring the use of software to automate egg counting.
                            </p>
                            <p className='pt-4   text-gray-700 leading-relaxed'>
                            This website was developed to analyze pictures using OpenCV and highlight where the mosquito eggs are located. By automating the counting process, the experiment became more efficient, eliminating the need to count the eggs in the pictures manually. 
                            </p>
                            <p className='pt-4   text-gray-700 leading-relaxed'>
                            After the wet lab team completed the beetroot functional assay, we gathered egg count data. We aim to compare the egg counts obtained manually with those generated by the egg counter analyzer. By doing so, the results will provide insight into the consistency and reliability of the egg-counting analyzer compared to manual counting, allowing for a more accurate assessment of its performance. Below is an example of the results for a beetroot attractant assay (the values under “software” and “manual” refer to the number of eggs:
                            </p>
                            import React from 'react';
    <div className="mt-10 items-center justify-center flex overflow-x-auto">
    <table border="1" cellPadding="10">
      <caption className="border border-gray-300">Assay done on August 23rd</caption>
      <thead>
        <tr>
          <th className="border border-gray-300"></th>
          <th className="border border-gray-300"></th>
          <th className="border border-gray-300">Type of substrate</th>
          <th className="border border-gray-300">Software count</th>
          <th className="border border-gray-300">Manual count</th>
          <th className="border border-gray-300">Accuracy (%)</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td className="border border-gray-300">Trial 1</td>
          <td className="border border-gray-300 px-8">B1 </td>
          <td className="border border-gray-300">Beetroot </td>
          <td className="border border-gray-300">343</td>
          <td className="border border-gray-300">625</td>
          <td className="border border-gray-300">54.88%</td>
        </tr>
        <tr>
          <td className="border border-gray-300"></td>
          <td className="border border-gray-300 text-center">B2 </td>
          <td className="border border-gray-300">ddH2O</td>
          <td className="border border-gray-300">100</td>
          <td className="border border-gray-300">99</td>
          <td className="border border-gray-300">98.99%</td>
        </tr>
        <tr>
          <td className="border border-gray-300">Trial 2</td>
          <td className="border border-gray-300 text-center">B2</td>
          <td className="border border-gray-300">Hay</td>
          <td className="border border-gray-300">53</td>
          <td className="border border-gray-300">58</td>
          <td className="border border-gray-300">91.38%</td>
        </tr>
        <tr>
          <td className="border border-gray-300"></td>
          <td className="border border-gray-300 text-center">B2</td>
          <td className="border border-gray-300">Beetroot</td>
          <td className="border border-gray-300">554</td>
          <td className="border border-gray-300">614</td>
          <td className="border border-gray-300">90.23%</td>
        </tr>
        <tr>
          <td className="border border-gray-300">Trial 3</td>
          <td className="border border-gray-300 text-center">B3</td>
          <td className="border border-gray-300">ddH2O</td>
          <td className="border border-gray-300">45</td>
          <td className="border border-gray-300">41</td>
          <td className="border border-gray-300">90.24%</td>
        </tr>
        <tr>
          <td className="border border-gray-300"></td>
          <td className="border border-gray-300 text-center">B3</td>
          <td className="border border-gray-300">Hay</td>
          <td className="border border-gray-300">90</td>
          <td className="border border-gray-300">114</td>
          <td className="border border-gray-300">78.95%</td>
        </tr>
        <tr>
          <td className="border border-gray-300"></td>
          <td className="border border-gray-300 text-center">B3</td>
          <td className="border border-gray-300">Beetroot</td>
          <td className="border border-gray-300">392</td>
          <td className="border border-gray-300">371</td>
          <td className="border border-gray-300">94.34%</td>
        </tr>
        <tr>
          <td  className="border border-gray-300 text-center" colSpan="5">Average accuracy (%)</td>
          <td className="border border-gray-300">85.57%</td>
        </tr>
      </tbody>
    </table>
    </div>
    <p className='mt-2 text-sm text-gray-700 leading-relaxed'>
    Table 1. The result for beetroot attractant assay using our self-developed egg-counting analyzer.
    </p>
    <img
        src={Analyze}
        alt=''
        className='mt-5 w-3/4 md:w-100 h-auto rounded-lg shadow-lg'
    />
    <p className='mt-2 text-sm text-gray-700 leading-relaxed'>
    Figure 1. The accurate and error rates of our self-developed egg-counting analyzer. 
    </p>
    <p className=' text-2xl font-bold mt-8 text-black'>
    Results
        </p>
        <p className='mt-2 text-m text-gray-700 leading-relaxed'>
    An analysis of the accuracy and error rates of our egg-count analyzer shows that statistically our data is accurate to a significant extent. The data produced by our egg-counting analyzer presents data that is significantly accurate with a P-value less than 0.0001 meaning that the difference between the accuracy and the error is statistically significant. This proves that our analyzer performs better and more accurately, revealing it to be highly reliable with an accuracy rate far surpassing the error rate.
    </p>
    <p className=' text-2xl font-bold mt-8 text-black'>
    Benefits
        </p>
        <p className='mt-2 text-m text-gray-700 leading-relaxed'>
        The development of our egg-count software is also vital to the implementation of our sticky ovitrap in the future. We aim to partner with public health organizations in the distribution of our trap as detailed in our business plan. Our egg-count software can support the public health officials’ analysis of the success rate of our trap and the identification of hotspots in the area which allows for faster interventions to prevent outbreaks and provides data for better resource allocation in areas with a higher chance for outbreaks. Implementing an egg-count software can also help in the research of mosquito oviposition behavior which can support the development of future public health strategies. Overall, this can make the public health officials’ jobs easier and much more efficient by providing accurate data on the oviposited eggs caught by our trap.
    </p>
    <p className=' text-2xl font-bold mt-8 text-black'>
    Limitations
        </p>
        <p className='mt-2 text-m text-gray-700 leading-relaxed'>
        While the table provides a clear comparison between the manually counted and software-generated results, it is important to acknowledge certain limitations. One limitation of the egg-counting software is the sensitivity to darker spots and shaded areas. Around the darker areas, the software starts to count the shaded pixels as eggs. This leads to an overestimation in egg count and results that are significantly higher and extremely inaccurate. In addition, if the paper strip does not fit perfectly in the frame due to the cropping of the image to fit the egg-counter screen, eggs outside the frame may be cut off, potentially undermining the egg count. Thus, we consider these limitations when recording our data, ensuring there are clearer and brighter photographs so that the software can more accurately count the eggs.
    </p>
    <p className=' text-2xl font-bold mt-8 text-black'>
    Conclusion
        </p>
        <p className='mt-2 text-m text-gray-700 leading-relaxed'>
        In conclusion, the comparative analysis demonstrates that the software can carry out data collection procedures in functional assays without significant deviations from the actual value. Refinements to the software, as well as further trials and tests, can help improve its precision, making it useful in future studies to reduce the possibility of errors. The perfected software will also be helpful to public health officials in the future in the implementation and distribution of our trap.
    </p>
    </section>
    </div>
                    <div className='pb-12'>
                        <section id='s2'>
                            <h2 className='text-2xl md:text-3xl font-bold text-[#C94C67] leading-relaxed'>
                                Making Process
                            </h2>
                            <p className='pt-4'>
                                Therefore, we implemented OpenCV using Python code.
                                This begins with a transfer of the image into “Gray Image”.
                                The next step is the assigning of pixel values, called
                                “Threshold Image”. Thirdly, it turns into a “Dilated Image”.
                                After this process, it will start finding the contour.
                                In other words, it will begin finding the specific place
                                of the larvae. Overall, this Egg Count Software provides
                                precise results for counting the eggs.
                            </p>
                             <br />
                            <div className='yellow-box text-center text-[#6C4E52] font-bold'>
                                <img src={EggAnalyzer} alt='analyzer' width='400px' />
                                <p className='pt-4'> Overview of the Analyzer</p>
                            </div>

                            <div className="grid grid-cols-3 pr-80 ">
                                <div>
                                    <p>
                                        <img
                                            src={OpenCV}
                                            alt="opencv logo"
                                            className="p-8 w-84 h-auto hover:opacity-70 transition-opacity"
                                        />
                                    </p>
                                </div>
                                <div>
                                    <p className="text-center text-8xl pr-4">+</p>
                                </div>
                                <div>
                                    <p>
                                        <img
                                            src={Python}
                                            alt="python logo"
                                            className="p-8 w-32 h-auto hover:opacity-70 transition-opacity"
                                        />
                                    </p>
                                </div>
                            </div>



                            <h1 className='font-bold text-3xl italic text-[#C94C67]'>OpenCV Analyzing Process</h1>
                            <br />
                            <div className='yellow-box text-center'>
                                <strong className=' text-bottom text-xl pt-4 text-[#6C4E52]'>1. Gray Image</strong>
                                <img src={EggGray} alt='grayEgg' width='400px'   className='rounded-xl'/>

                            </div>
                            <br />
                            <p className='text-6xl pl-48'>⇩</p>
                            <br />
                            <div className='yellow-box text-center pb-4'>
                                <strong className=' text-bottom text-xl pt-4 text-[#6C4E52]'>2. Threshold Image</strong>
                                <img src={EggThreshold} alt='threshold' width='400px'   className='rounded-xl'/>
                            </div>
                            <br />
                            <p className='text-6xl pl-48'>⇩</p>
                            <br />
                            <div className='yellow-box text-center'>
                                <strong className=' text-bottom text-xl pt-4 text-[#6C4E52]'>3. Dilated Image</strong>
                                <img src={EggDilated} alt='dilated' width='400px'   className='rounded-xl'/>
                            </div>
                            <br />
                            <p className='text-6xl pl-48'>⇩</p>
                            <br />
                            <div className='yellow-box text-center'>
                                <strong className=' text-bottom text-lg text-[#6C4E52]'>4. Overlay Image</strong>
                                <img src={EggOverlay} alt='overlay' width='400px'  className='rounded-xl'/>
                            </div>
                            <br />
                            <h1 className='font-bold text-3xl italic pt-8 text-[#C94C67]'>New Features</h1>
                            <br />
                            <p>
                                To address the accuracy problems associated with the
                                shadow from the eggs pictures we've taken, we added
                                new features to the software.
                            </p>
                            <ul className='list-disc font-bold p-5'>
                                <li>ROI selection</li>
                                <li>Improved openCV features for higher precision</li>
                            </ul>
                            <br />
                            <div className="flex justify-between">
                                <div className="w-1/2 p-5">
                                    <br />
                                    <br />
                                    <p className="underline">New User Interface: </p>
                                    <ul className="list-decimal p-5">
                                        <li>Load Image - upload image</li>
                                        <li>Select ROI - select area with eggs</li>
                                        <li>Process Image - run the image analyzed results</li>
                                    </ul>
                                </div>
                                <div className="w-1/2 p-5 yellow-box">
                                    <img src={EggUI} alt="Eggs-H2" className="md:w-96 h-auto" />
                                </div>
                            </div>
                            <br />
                            <p className='font-bold'> Region of Interest(ROI) Selection: (the blue frame)</p>
                            <br />
                            <div className='yellow-box'>
                                <img src={EggH2} alt="Eggs-H2" className="md:w-120 h-auto" />
                            </div>
                            <br />
                            <p>Mosquito Analyzer code available at: </p>
                            <p
                                className="text-blue-500 hover:text-blue-300 transition-colors duration-300"
                            >
                                https://mosquito-egg-count-software.vercel.app/#/
                            </p>
                        </section>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Software;